// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"HeaderSearch_searchBox__3ghjt","searchInput":"HeaderSearch_searchInput__1t6a3","searchButton":"HeaderSearch_searchButton__3O0Dp"};